import React, { useState, useEffect } from 'react';
import vr from '../../../../../utils/Verifiers';
import VainillaDialogV2 from '../../../../../utils/VainillaDialogv2';
import CloseButton from '../../../../sharecomponents/CloseButton copy';

const Reporte_siembra_detalle = (p) => {
    const close = p.close ?? (() => { });
    const semana = p.semana ?? '';
    const dia = p.dia ?? '';
    const data_send = p.data_send ?? {};
    const [loader, setloader] = useState(false);
    const ldr = (<div className='vw-100 vh-100 top-left-front bg-white5 blur-s'><div className='loader' /></div>);
    const [dialog, setdialog] = useState({ show: false });
    const [listaDetalles, setListaDetalles] = useState([]);

    useEffect(() => {
        getDetalles();
    }, []);

    const getDetalles = async () => {
        let resp = await vr.getDataAPI('reportes/vivero_dia/simebra/detalles', data_send, setloader, setdialog);
        if (!resp.estatus) {
            vr.activeDialog(setdialog, resp.msj);
            setTimeout(() => {
                close();
            }, 3000);
            return;
        }
        setListaDetalles(generarDetalles(resp.data));
    }

    const generarDetalles = (apiList) => {
        let det = [];
        apiList.forEach(element => {
            det.push({ bloque: element.bloque, id: element.id, reporte: formatearReporte(element.reporte) });
        });
        return det;
    }

    const formatearReporte = (info) => {
        let sintesis = {};
        let keys = Object.keys(info);

        keys.forEach(key => {
            let arrayKey = key.toLocaleUpperCase().split('_');
            let len = arrayKey.length;
            let periodo = arrayKey[len - 1].toLowerCase();
            let nombre = arrayKey.slice(0, len - 1).join(' ');
            if (!sintesis[nombre]) {
                sintesis[nombre] = { nombre: nombre };
            }
            sintesis[nombre][periodo] = info[key];
        });
        return Object.values(sintesis);
    }

    const numberFormated = (value) => {
        let number = vr.numberFormat(value, 'N/A');
        if (number === 'N/A') return number;
        return number.toLocaleString('en-US');
    }

    return (
        <div className='col-lg-12 vh-100 m-0 blur-xl text-center p-1' style={vr.floatPageStyle()}>
            <div className='w-100' style={{ position: "sticky", top: 0, zIndex: 5 }}>
                <CloseButton close={close} buttonStyle='btn btn-sm btn-danger bg-red3 mt-2 shadow ps-5 pe-5 scale-continue-05 border border-warning border-3 text-bold round-xxl' />
            </div>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                {
                    listaDetalles.map((reporte, i) => <React.Fragment key={`reporte-${i}`}>
                        <div className='bw-500 m-1 round-s bg-white shadow p-1 mb-3' >
                            <table className='table table-sm table-striped m-0 p-0'>
                                <thead>
                                    <tr>
                                        <th scope='col' colSpan={3} className='text-center bg-dark text-white round-top-s border-none m-0 p-1'>{reporte.bloque} - <span className='text-xs text-bold'>Folio: {reporte.id}</span></th>
                                    </tr>
                                    <tr className=''>
                                        <th scope='col' className='text-center bg-dark text-white border-none text-s text-300 p-0'>CONCEPTO</th>
                                        <th scope='col' className='text-center bg-dark text-white border-none text-s text-300 p-0'>SEMANA<span className='text-xs ms-2 text-bold'>{semana}</span></th>
                                        <th scope='col' className='text-center bg-dark text-white border-none text-s text-300 p-0'>Dia<span className='text-xs ms-2 text-bold'>{dia}</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        reporte.reporte.map((rep, i) =>
                                            <tr key={`reporte-${i}`} >
                                                <th className='text-start'>{rep.nombre}</th>
                                                <td className='border-end'>{numberFormated(rep.semana)}</td>
                                                <td>{numberFormated(rep.dia)}</td>
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </React.Fragment>)
                }
                <div className='w-100 m-0 p-0 mt-5 mb-5' />
            </div>
            <VainillaDialogV2 data={dialog} />
            {loader && ldr}
        </div>
    )
}

export default Reporte_siembra_detalle;